import React, { useState } from "react";
import {
  MainContainer,
  PartDetailText,
  TitleAndImageContainer,
  PartName,
  TopLineContainer,
  PART_SEARCH_DRAWER_WIDTH,
  INVENTORY_DRAWER_WIDTH,
} from "./PartDrawerStyles";
import { FakeLink } from "../../../constants/Styles";
import CircleBadge from "../../common/CircleBadge";
import { useAppSelector } from "../../../utils/hooks/store";
import PartDetails from "./PartDetails";
import Inventory from "./Inventory";
import { EmptyBackground } from "../ComponentsSearchPage/ComponentsSearchPageStyles";
import { ADMIN_GROUP, ENGINEER_GROUP } from "../../../utils/group";
import PartFootprintSummary from "../../FootprintSummary";
import FlashPCBDrawer from "../../common/FlashPCBDrawer";
import usePart from "../../../utils/hooks/commonly-stored/parts";
import LoadingIcon from "../../common/LoadingIcon";

export enum PartDrawerPageMode {
  PART_DETAILS = "part_details",
  INVENTORY = "inventory",
}

export default function PartDrawer({
  partId,
  onClose,
  setIsUpdated,
  initialPageMode,
}: {
  partId: string | null;
  onClose: () => void;
  setIsUpdated?: (arg: boolean) => void;
  initialPageMode?: PartDrawerPageMode;
}) {
  const { part } = usePart(partId);
  const [pageMode, setPageMode] = useState<PartDrawerPageMode>(
    initialPageMode || PartDrawerPageMode.PART_DETAILS,
  );

  const { groups } = useAppSelector((state) => state.auth);
  const canEditPart =
    groups.includes(ENGINEER_GROUP) || groups.includes(ADMIN_GROUP);

  const close = () => {
    onClose();
  };

  if (partId === null) {
    return null;
  }

  return (
    <FlashPCBDrawer
      isOpen
      onRequestClose={close}
      width={
        pageMode === PartDrawerPageMode.INVENTORY
          ? INVENTORY_DRAWER_WIDTH
          : PART_SEARCH_DRAWER_WIDTH
      }
      maxWidth={"100vw"}
    >
      {part === null ? (
        <EmptyBackground>
          <LoadingIcon
            text={"Loading part..."}
            centerHorizontally
            centerVertically
          />
        </EmptyBackground>
      ) : (
        <MainContainer>
          <TopLineContainer>
            {canEditPart && (
              <>
                <FakeLink
                  onClick={() => setPageMode(PartDrawerPageMode.PART_DETAILS)}
                >
                  Part details
                </FakeLink>
                <FakeLink
                  onClick={() => setPageMode(PartDrawerPageMode.INVENTORY)}
                >
                  View inventory
                </FakeLink>
              </>
            )}
            <CircleBadge
              iconProps={{
                src: "/icons/cancel.svg",
                alt: "cancel",
              }}
              onClick={close}
            />
          </TopLineContainer>
          <TitleAndImageContainer>
            <PartFootprintSummary part={part} />
            <div>
              <PartDetailText>Part Detail</PartDetailText>
              <PartName>{part.name}</PartName>
            </div>
            {part.manufacturer !== null && (
              <div>
                <PartDetailText>Manufacturer</PartDetailText>
                <PartName>{part.manufacturer}</PartName>
              </div>
            )}
          </TitleAndImageContainer>
          {pageMode === PartDrawerPageMode.PART_DETAILS && (
            <PartDetails part={part} canEditPart={canEditPart} />
          )}
          {pageMode === PartDrawerPageMode.INVENTORY && (
            <Inventory setIsUpdated={setIsUpdated} part={part} />
          )}
        </MainContainer>
      )}
    </FlashPCBDrawer>
  );
}
